import React from "react"
import { Box, css, Text, useTheme } from "@chakra-ui/react"
import { useRouter } from "next/router"

import Colors from "@constants/colors"
import { bp } from "@utils/MediaQueries"

import { handleFormSubmission } from "@utils/api/contact"
import { ContactAndSupportDataProps } from "@utils/api"
import { RES_SUCCESS, FORM_SUCCESS_ROUTE, ERROR_MESSAGE } from "@constants/api"

import ContactUsForm from "@components/form/forms/ContactForm"

interface ContactFormProps {
  subjectOptions: string[]
  contactEmail: string
}

const ContactForm: React.FC<ContactFormProps> = ({
  subjectOptions,
  contactEmail,
}) => {
  const [errorState, setErrorState] = React.useState(false)
  const [isFetchingData, setIsFetchingData] = React.useState(false)
  const router = useRouter()
  const theme = useTheme()

  const styles = css({
    fontFamily: "Avenir",
    width: bp("100%", null, "calc(8/16 *100vw)"),
    margin: "0 auto",
    pb: bp("5rem", null, "10rem"),
    paddingX: bp("1rem", null, "0"),
    header: {
      fontSize: bp("23px", null, "33px"),
      fontWeight: "800",
      paddingBottom: "2rem",
    },
    p: {
      fontSize: "16px",
      color: Colors.midAccessible,
      paddingBottom: "2rem",
    },
  })(theme)

  const onFormSubmit = async (data: ContactAndSupportDataProps) => {
    setIsFetchingData(true)
    const res: any = await handleFormSubmission(data, contactEmail)
    setIsFetchingData(false)
    if (res.status === RES_SUCCESS) {
      router.push(FORM_SUCCESS_ROUTE)
    } else {
      setErrorState(true)
    }
  }

  return (
    <Box css={styles}>
      <Box>
        <Text as="header">Contact Us</Text>
        <Text>
          Please supply as much information as possible so we can better serve
          you. When you are ready, please click the "Send" at the bottom of the
          page and our customer service team will respond as soon as possible.
        </Text>
      </Box>
      <ContactUsForm
        subjectOptions={subjectOptions}
        onSubmit={(data: ContactAndSupportDataProps) => onFormSubmit(data)}
        errorMessage={errorState ? ERROR_MESSAGE : undefined}
        isLoading={isFetchingData}
      />
    </Box>
  )
}

export default ContactForm
